import { jsx, jsxs } from 'react/jsx-runtime';

function ErrorHandler(_ref) {
  let {
    error,
    resetErrorBoundary
  } = _ref;
  console.log('ErrorHandler.error', error);
  return jsx("div", {
    style: {
      minHeight: '100vh',
      background: '#101010',
      color: '#eeeeee'
    },
    children: jsx("div", {
      children: jsxs("div", {
        style: {
          display: 'flex',
          gap: '1rem',
          alignItems: 'flex-start'
        },
        children: [jsx("div", {
          children: "Unhandled Runtime Error"
        }), jsx("div", {
          children: error.message
        }), error.stack && jsx("div", {
          children: error.stack
        }), typeof resetErrorBoundary === 'function' && jsx("button", {
          onClick: resetErrorBoundary,
          children: "Try again?"
        })]
      })
    })
  });
}

export { ErrorHandler };
//# sourceMappingURL=error-handler.js.map
